import { createSelector } from 'reselect';
import { servicesSelectors } from '@lifesize/nucleus';
import get from 'lodash/get';

const hasInitializedServices = state => get(state, 'app.jwt.hasInitializedServices');

export const isReconnecting = createSelector(
  servicesSelectors.selectVerifyingConnection,
  servicesSelectors.selectConnecting,
  servicesSelectors.selectWillRetry,
  hasInitializedServices,
  servicesSelectors.selectConnected,
  (isVerifying, isCurrentlyConnecting, isWillRetry, hasInitializedServices, isNPConnected) => {
    const isConnecting = isVerifying || isCurrentlyConnecting || isWillRetry;
    const isReconnecting = isConnecting && hasInitializedServices && !isNPConnected;
    return isReconnecting;
  }
);
